import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="card card-narrow center">
      <p className="error-code">404</p>
      <h1>Seite nicht gefunden</h1>
      <p className="muted">Diese Seite existiert nicht.</p>
      <Link className="btn" to="/">
        Zur Startseite
      </Link>
    </section>
  );
}
